import { render, staticRenderFns } from "./SocialAuthOld.vue?vue&type=template&id=0251d2fa&"
var script = {}
import style0 from "./SocialAuthOld.vue?vue&type=style&index=0&id=0251d2fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports